// Utilidades puras del detalle de UNA inspección (página /inspecciones/:id y
// su PDF individual). La huella es el SHA-256 del JSON canónico de la fila tal
// como la devuelve la base: claves ordenadas en todos los niveles, sin
// espacios, UTF-8. El mismo texto se puede descargar desde el detalle
// ("Datos (JSON)") y comprobar con `shasum -a 256`.
import { sha256Hex } from './auditoriaCsv';

const ordenar = (v) => {
  if (Array.isArray(v)) return v.map((x) => (x === undefined ? null : ordenar(x)));
  if (v && typeof v === 'object') {
    const out = {};
    for (const k of Object.keys(v).sort()) {
      if (v[k] !== undefined) out[k] = ordenar(v[k]);
    }
    return out;
  }
  return v;
};

export const jsonCanonico = (valor) => JSON.stringify(ordenar(valor));

export const huellaInspeccion = (fila) => sha256Hex(jsonCanonico(fila));

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const idInspeccionValido = (id) => typeof id === 'string' && UUID.test(id);

export const rutaInspeccion = (id) => `/inspecciones/${id}`;

export const nombreArchivoInspeccion = (r, ext) =>
  `cables-inspeccion-${r?.fecha || 'sin-fecha'}-${String(r?.id || '').slice(0, 8)}.${ext}`;

const ORIGEN = {
  online: 'En línea',
  'offline-sync': 'Sin conexión, sincronizada después',
  maintainx: 'Importada de MaintainX',
  declarada: 'Declarada (reportada en el grupo de Operaciones)',
};
export const origenTexto = (o) => (o ? ORIGEN[o] || o : 'Sin dato');
